import React, { useEffect, useState } from 'react'
import InvoiceItem from './invoiceItem'
import { Skeleton } from 'antd'

const InvoiceList = ({ invoices, onInvoiceClick, loading }) => {
  const [filteredInvoices, setFilteredInvoices] = useState(invoices);
  const [selectedTab, setSelectedTab] = useState('ALL');

  const invoicesFilter = (status) => {
    if (status === 'ALL' || !status) return invoices;

    return invoices.filter((invoice) => {
      return invoice.status === status
    })
  }

  useEffect(() => {
    setFilteredInvoices(invoicesFilter(selectedTab));
  }, [invoices, selectedTab]);

  const tabOptions = [
    { label: 'Todas', value: 'ALL', selected: selectedTab === 'ALL' },
    { label: 'Abertas', value: 'OPEN', selected: selectedTab === 'OPEN' },
    { label: 'Fechadas', value: 'CLOSED', selected: selectedTab === 'CLOSED' },
    { label: 'Pagas', value: 'PAID', selected: selectedTab === 'PAID' },
    { label: 'Atrasadas', value: 'OVERDUE', selected: selectedTab === 'OVERDUE' },
  ]

  return (
    <div className="tab-container">
      <ul className="tabs">
        {
          tabOptions.map((tab) => (
            <li className={`tab-item ${tab.selected ? 'active' : ''}`} key={tab.value} onClick={() => setSelectedTab(tab.value)}>{tab.label}</li>
          ))
        }
      </ul>

      <div className="tab-content">
        {
          loading ? (
            <>
              <Skeleton active paragraph={{ rows: 2 }} />
              <Skeleton active paragraph={{ rows: 2 }} />
            </>
          ) : filteredInvoices?.length > 0 ? (
            <>
              {filteredInvoices.map((invoice) => (
                <InvoiceItem key={invoice.id} invoice={invoice} onInvoiceClick={onInvoiceClick} />
              ))}
            </>
          ) : (
            <div className="empty-invoices-message" style={{ textAlign: 'center', padding: '2rem 1rem', color: 'var(--text-secondary, #888)' }}>
              <p style={{ fontSize: '1rem', margin: 0 }}>Nenhuma fatura encontrada para este filtro.</p>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default InvoiceList;